import React from 'react';
import AurDrawer from '../../../common/aur-drawer/AurDrawer';
import {
  IQueryFieldHeaderDrawerProps,
  QueryFieldHeaderDrawer,
} from './components/QueryFieldHeaderDrawer';
import {
  IQueryFieldSearchDrawerProps,
  QueryFieldSearchDrawer,
} from './components/QueryFieldSearchDrawer';

interface IQueryFieldDrawerProps {
  open: boolean;
  headerProps: IQueryFieldHeaderDrawerProps;
  searchProps?: IQueryFieldSearchDrawerProps;
}

const QueryFieldDrawer: React.FC<
  React.PropsWithChildren<IQueryFieldDrawerProps>
> = ({open, headerProps, searchProps, children}) => {
  return (
    <AurDrawer
      className={'query-field-drawer'}
      data-testid="query-field-drawer"
      open={open}
      anchor={'right'}
      drawerRootSx={{
        display: 'flex',
        flexDirection: 'column',
      }}
      drawerHeader={
        <>
          <QueryFieldHeaderDrawer {...headerProps} />
          {searchProps && <QueryFieldSearchDrawer {...searchProps} />}
        </>
      }
      drawerContent={children}
    />
  );
};

export {QueryFieldDrawer};
